import { currency } from "../lib/format.js";
import { TeamTreeTable } from "../components/teamTreeTable.jsx";
import { Metric, Topbar } from "../components/ui.jsx";

export function TeamPerformanceView({ report, openEmployee, openTarget, openExpense }) {
  const rows = report?.teamRollups ?? [];
  const visibleTeams = rows.length;
  const totalReps = Math.max(...rows.map((row) => Number(row.salesReps || 0)), 0);
  const followUpsDue = Math.max(...rows.map((row) => Number(row.followUpsDue || 0)), 0);

  return (
    <>
      <Topbar title="Team Performance" subtitle="Expandable top-down view of sales health, activity, pipeline, and revenue roll-up." />
      <section className="metric-grid">
        <Metric label="Visible Teams" value={visibleTeams} />
        <Metric label="Roll-Up Reps" value={totalReps} />
        <Metric label="Revenue Target" value={currency(report?.targetTotals?.revenueTarget ?? 0)} />
        <Metric label="Achieved Revenue" value={currency(report?.targetTotals?.achievedRevenue ?? 0)} />
        <Metric label="Pending Follow-ups" value={followUpsDue} />
        <Metric label="Target Achievement" value={`${report?.targetTotals?.achievementPercent ?? 0}%`} />
      </section>
      <section className="panel spaced">
        <h2>Sales Department Performance Grid</h2>
        <TeamTreeTable rows={rows} onOpenEmployee={openEmployee} onAssignTarget={openTarget} onAddExpense={openExpense} />
      </section>
    </>
  );
}
